import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import Footer from "@/components/Footer";
import { LanguageProvider } from "@/hooks/useLanguage";
import { HelmetProvider } from "react-helmet-async";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import AppSidebar from "@/components/AppSidebar";
import { lazy, Suspense } from "react";
const Index = lazy(() => import("./pages/Index"));
const FaceChart = lazy(() => import("./pages/FaceChart"));
const Analyzer = lazy(() => import("./pages/Analyzer"));
const Quiz = lazy(() => import("./pages/Quiz"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Auth = lazy(() => import("./pages/Auth"));
const Profile = lazy(() => import("./pages/Profile"));
const Premium = lazy(() => import("./pages/Premium"));
const MakeupHistory = lazy(() => import("./pages/MakeupHistory"));
const Gallery = lazy(() => import("./pages/Gallery"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const About = lazy(() => import("./pages/About"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Support = lazy(() => import("./pages/Support"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <SidebarProvider>
              <div className="min-h-screen flex w-full">
                <AppSidebar />
                <div className="flex-1 flex flex-col min-w-0">
                  <header className="h-12 flex items-center border-b border-border px-3 md:hidden">
                    <SidebarTrigger />
                  </header>
                  <main className="flex-1">
                    <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-background"><div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin"></div></div>}>
                    <Routes>
                      <Route path="/" element={<Index />} />
                      <Route path="/face-chart" element={<FaceChart />} />
                      <Route path="/analyzer" element={<Analyzer />} />
                      <Route path="/quiz" element={<Quiz />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/blog/:id" element={<BlogPost />} />
                      <Route path="/auth" element={<Auth />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/premium" element={<Premium />} />
                      <Route path="/history" element={<MakeupHistory />} />
                      <Route path="/gallery" element={<Gallery />} />
                      <Route path="/reset-password" element={<ResetPassword />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/privacy" element={<Privacy />} />
                      <Route path="/support" element={<Support />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                    </Suspense>
                    <Footer />
                  </main>
                </div>
              </div>
            </SidebarProvider>
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  </HelmetProvider>
);

export default App;
